import React from 'react';
import { formatDocumentNumber } from '../utils/documentNumber';
import { getConfidenceLevel } from '../utils/confidence';
import { normalizeTagValue } from '../utils/tagUtils';
import { resolveMediaUrl } from '../utils/media';
import { getLaymenAuthorLabel } from '../utils/laymenAlias';
import TagChip from './TagChip';

const PostItem = React.forwardRef(({ post, selectedTags = [], selectedTagSet, onReadMore }, ref) => {
    const handleClick = () => {
        if (onReadMore) {
            onReadMore(post);
        }
    };

    const confidenceValue = Number(post?.confidenceRating ?? post?.confidenceScoreRating);
    const { label: confidenceLabel, tone: confidenceTone } = getConfidenceLevel(confidenceValue);

    const tags = Array.isArray(post.tags) ? post.tags : [];
    const normalizedSelectedTagSet = selectedTagSet instanceof Set
        ? selectedTagSet
        : new Set(Array.isArray(selectedTags) ? selectedTags.map(normalizeTagValue) : []);
    const thumbnailSrc = resolveMediaUrl(post?.thumbnail);
    const authorLabel = getLaymenAuthorLabel(post);

    return (
        <article className="post-item" ref={ref} data-post-id={post?._id || undefined}>
            {/* <span className="post-item__doc-number">{formatDocumentNumber(post.documentNumber ?? post.copyNumber)}</span> */}
            <span className="post-item__doc-number">{post.date}</span>
            <span className={`post-item__confidence-rating post-item__confidence-rating--${confidenceTone}`}>
                {confidenceLabel}
            </span>
            {thumbnailSrc && (
                <div className="post-item__thumbnail">
                    <img
                        src={thumbnailSrc}
                        alt={`Thumbnail for ${post.title}`}
                        loading="lazy"
                    />
                </div>
            )}

            <div className="post-item__content">
                <h3 className="post-item__title">{post.title}</h3>

                <div className="post-item__author-name">{authorLabel}</div>

                {tags.length > 0 && (
                    <div className="post-item__tags" aria-label="Tags">
                        {tags.map((tag, index) => {
                            const label = typeof tag === 'string' ? tag : String(tag ?? '');
                            const normalizedLabel = normalizeTagValue(label);
                            const isActiveTag = normalizedSelectedTagSet.has(normalizedLabel);

                            return (
                                <TagChip
                                    key={`${normalizedLabel}-${index}`}
                                    label={label}
                                    className="post-item__tag"
                                    isActive={isActiveTag}
                                />
                            );
                        })}
                    </div>
                )}

                <p className="post-item__description">{post.description}</p>

                <div className="post-item__footer">
                    <button className="post-item__action" onClick={handleClick}>
                        Read More
                    </button>
                </div>
            </div>
        </article>
    );
});

export default PostItem;
